
import React, { useState } from 'react'
import { useFormik } from "formik";
import * as Yup from "yup";
import { message } from "antd";
import Loader from '../Loader/Loader';
import { updateStaff } from '../../webServices/Apis';

const EditSupport = ({ showEditModal, setShowEditModal, action, setAction, selectedStaff }) => {
    const [open, setOpen] = useState(showEditModal)
    const [loading, setLoading] = useState(false)

    const formik = useFormik({
        initialValues: {
            firstName: selectedStaff.firstName,
            lastName: selectedStaff.lastName,
            email: selectedStaff.email,
            active: selectedStaff.active ? 'active' : 'inactive'
        },
        validationSchema: Yup.object({
            firstName: Yup.string().required("First name can not be empty").max(30, "Fist name should not be more than 30 characters").trim("First name should not have spaces").matches(/^[a-zA-Z]+$/, "First name should contains only letters also not spaces"),
            lastName: Yup.string().required("Last name can not be empty").max(30, "Last name should not be more than 30 characters").trim("Last name should not have spaces").matches(/^[a-zA-Z]+$/, "Last name should contains only letters also not spaces"),
            email: Yup.string().email("Invalid email").required("Email is required").matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter a valid email address"
            )
        }),

        onSubmit: async (values, { resetForm, setSubmitting }) => {
            try {
                setLoading(true)
                const response = await updateStaff(selectedStaff.id, { ...values, active: values.active === 'active' ? true : false })
               
                if (response?.data?.success) {
                    message.success(response?.data?.message)
                    resetForm()
                    setOpen(false)
                    setShowEditModal(false)
                    setAction(!action)
                }
            } catch (error) {
                if (error?.response?.status === 401) {
                    message.error("Session Timeout !");
                    localStorage.clear()
                    window.location.href = "/login";
                    return;
                }
                if (error?.response?.status === 413) {
                    message.error("File size is too large")
                    return;
                }
                message.error(
                    error?.response?.data?.message ||
                    "Error while creating sub contractor"
                );

            } finally {
                setSubmitting(false);
                setLoading(false);
            }
        }

    })


    const closeModal = () => {
        setOpen(false)
        setShowEditModal(false)
    }
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-lg shadow-lg w-[700px] h-[600px] overflow-y-auto scrollbar-hidden">
                <h3 className="text-xl font-bold mb-2 text-center bg-blue-950 py-2 text-white">Update Support Staff</h3>
                <form onSubmit={formik.handleSubmit} className="p-8">

                    <div className="flex gap-2 ">
                        <div className='w-full'>
                            <label className="block mb-1">First Name</label>
                            <input
                                type="text"
                                name="firstName"
                                className="border border-gray-800 p-2 w-full"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.firstName}

                            />
                            {formik.touched.firstName && formik.errors.firstName && (
                                <p className="text-red-600">{formik.errors.firstName}</p>
                            )}
                        </div>

                        <div className='w-full'>
                            <label className="block mb-1">Last Name</label>
                            <input
                                type="text"
                                name="lastName"
                                className="border border-gray-800 p-2 w-full"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.lastName}
                            />
                            {formik.touched.lastName && formik.errors.lastName && (
                                <p className="text-red-600">{formik.errors.lastName}</p>
                            )}
                        </div>
                    </div>

                    <div className='w-full mt-2'>
                        <label className="block mb-1">Email</label>
                        <input
                            type="text"
                            name="email"
                            className="border border-gray-800 p-2 w-full bg-gray-300"
                            // onChange={formik.handleChange}
                            // onBlur={formik.handleBlur}
                            value={formik.values.email}
                            disabled
                        />
                    </div>

                    <div className='flex gap-2'>
                        <div className='w-full mt-2'>
                            <label className="block mb-1">Company Name</label>
                            <input
                                type="text"
                                name="name"
                                className="border border-gray-800 p-2 w-full bg-gray-300"

                                value={selectedStaff.companyName}
                                disabled
                            />

                        </div>

                        <div className='w-full mt-2'>
                            <label className="block mb-1">Status</label>
                            <select
                                name="status"
                                value={(formik.values.active === 'active') ? 'Active' : 'Inactive'} // Bind to the "status" field
                                onChange={(e) => {
                                    const isActive = e.target.value === "Active" ? 'active' : 'inactive'; // Convert "Active" to true, "Inactive" to false
                                    formik.setFieldValue('active', isActive); // Update Formik's "status" field with boolean
                                }}
                                className="border border-gray-800 p-2 w-full bg-white"
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>

                        </div>
                    </div>


                    <div className='flex gap-2'>
                        <div className='w-full mt-2'>
                            <label className="block mb-1">Subscription Start Date</label>
                            <input
                                type="text"
                                name="name"
                                className="border border-gray-800 p-2 w-full bg-gray-300"

                                value={selectedStaff.startSubscription}
                                disabled
                            />

                        </div>

                        <div className='w-full mt-2'>
                            <label className="block mb-1">Subscription End Date</label>
                            <input
                                type="text"
                                name="name"
                                className="border border-gray-800 p-2 w-full bg-gray-300"

                                value={selectedStaff.endSubscription}
                                disabled
                            />

                        </div>
                    </div>


                    <div className='w-full mt-2'>
                        <label className="block mb-1">Address</label>
                        <textarea
                            rows={2}
                            type="text"
                            name="name"
                            className="border border-gray-800 p-2 w-full bg-gray-300"

                            value={selectedStaff.address}
                            disabled
                        />

                    </div>

                    <div className="flex justify-end gap-6 mt-6">
                        <button onClick={closeModal} className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
                        >
                            Cancel
                        </button>
                        {/* <button type="submit" className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2">
                Create
              </button> */}
                        <button type='submit' className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2"
                        >
                            Update
                        </button>

                    </div>
                    {loading && (
                        <Loader />
                    )}
                </form>
            </div>
        </div>
    )
}

export default EditSupport